function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { AelfIcon } from "../../icon/AelfIcon";
var AelfSVGComponent = function AelfSVGComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.95 16c0-5.55 4.499-10.049 10.049-10.049a10.04 10.04 0 0 1 8.41 4.548H22.4a.4.4 0 0 0-.4.4v1.7c0 .221.179.4.4.4l5.6.001a1 1 0 0 0 1-1V6.4a.4.4 0 0 0-.4-.4h-1.7a.4.4 0 0 0-.4.4v2.726a12.538 12.538 0 0 0-10.5-5.675C9.069 3.451 3.449 9.07 3.449 16 3.45 22.93 9.07 28.549 16 28.549c5.646 0 10.418-3.728 11.995-8.855a.39.39 0 0 0-.274-.49l-1.64-.447a.413.413 0 0 0-.499.279c-1.287 4.066-5.092 7.013-9.582 7.013-5.55 0-10.049-4.5-10.049-10.05Z"
  }));
};
var componentName = 'RefreshOutlined';
export var RefreshOutlined = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(AelfIcon, _extends({
    component: AelfSVGComponent,
    ref: ref
  }, props));
});
RefreshOutlined.displayName = componentName;